<template>
  <transition enter-active-class="transition-[opacity,transform] duration-300 ease-in"
              enter-from-class="opacity-0 translate-y-full"
              leave-active-class="transition-[opacity,transform] duration-200 ease-out"
              leave-to-class="opacity-0 translate-y-full"
  >
    <slot></slot>
  </transition>
</template>

<script>
export default {
  name: "InputLabelTransition",
  functional: true
}
</script>

<style scoped>

</style>